/**
 * prefers-reduced-motion 감지 — docs/DESIGN.md §10.4.
 *
 * OBS의 브라우저 소스는 일반 크롬이므로 media query가 동작합니다.
 * 시청자 시스템 설정을 존중하여 멀미/민감성 대응.
 */
export function prefersReducedMotion(mediaQueryFn?: (q: string) => { matches: boolean }): boolean {
  const mql = mediaQueryFn
    ? mediaQueryFn('(prefers-reduced-motion: reduce)')
    : typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;
  return Boolean(mql?.matches);
}

/**
 * 변화를 구독합니다. 구독 해제 함수를 반환.
 * 브라우저 env 외에서는 no-op.
 */
export function subscribeReducedMotion(cb: (reduced: boolean) => void): () => void {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {};
  const mql = window.matchMedia('(prefers-reduced-motion: reduce)');
  const handler = (e: MediaQueryListEvent): void => cb(e.matches);
  mql.addEventListener('change', handler);
  cb(mql.matches);
  return () => mql.removeEventListener('change', handler);
}
